module.exports = __webpack_public_path__ + "img/Refresh - Pink.48f95dd1.png";